import { render, staticRenderFns } from "./ReadyAppealsList.vue?vue&type=template&id=551d7e60&scoped=true"
import script from "./ReadyAppealsList.vue?vue&type=script&lang=js"
export * from "./ReadyAppealsList.vue?vue&type=script&lang=js"
import style0 from "./ReadyAppealsList.vue?vue&type=style&index=0&id=551d7e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d7e60",
  null
  
)

export default component.exports